// src/utils/systemLabels.js
//
// How an organ system from the Deterministic Model's evidence (deterministic_feature_flags
// "systems" map, e.g. "CARDIOVASCULAR") is named on screen and in the exported PDF.
//
// Most systems read fine as the capitalised key. Three need help: the engine spells
// "HAEMATOLOGIC" with the British "ae" (older evidence may say HEMATOLOGIC), and two
// systems are not organs at all, so a bare "Oncology" or "General" would say too little to a
// reader. Oncology holds the tumour markers (CEA, PSA, AFP, CA-125 …) and General holds the
// screening markers that belong to no single organ (plain CRP, IgE, rheumatoid factor,
// amylase, procalcitonin, cultures).

const cap = (s) => String(s || '').charAt(0).toUpperCase() + String(s || '').slice(1).toLowerCase();

export const SYSTEM_DISPLAY = {
  HEMATOLOGIC:   'Haematologic',
  HEMATOLOGICAL: 'Haematologic',
  ONCOLOGY:      'Oncology (tumour markers)',
  GENERAL:       'General screening',
};

/** Display name for a system key, falling back to the capitalised key. */
export const systemDisplayName = (sys) => SYSTEM_DISPLAY[String(sys || '').toUpperCase()] || cap(sys);

// The word for a system inside a sentence of the form "Your … markers are all within normal
// range." Organ systems use the organ ("kidney"); the two non-organ systems read as
// "tumour markers" and "general screening markers".
export const SYSTEM_ORGAN = {
  RENAL: 'kidney', HEPATIC: 'liver', THYROID: 'thyroid', METABOLIC: 'metabolic',
  CARDIOVASCULAR: 'heart', HEMATOLOGIC: 'blood', HAEMATOLOGIC: 'blood', NUTRITIONAL: 'nutrient',
  ONCOLOGY: 'tumour', GENERAL: 'general screening',
};

/** The in-sentence word for a system, falling back to the lower-cased key. */
export const systemOrganWord = (sys) => SYSTEM_ORGAN[String(sys || '').toUpperCase()] || String(sys || '').toLowerCase();
